<template>
	<div class="page_footer">
		<div class="footer_wrapper">
			<div class="footer_info">
				<div class="f_menu">
					<div class="mitem">
						<h3>陕西陕煤检测科技有限公司</h3>
						<p>
							<span @click="joinFavorite">加入收藏</span>
							<span @click="$router.push({ name: 'contactUs' })">联系我们</span>
						</p>
					</div>
					<div class="mitem">
						<h3>联系电话</h3>
						<p>
							<span>{{ sysInfo.phone }}</span>
						</p>
					</div>
					<div class="mitem">
						<h3>友情链接</h3>
						<p>
							<a v-for="(v, i) in sysInfo.blogroll" :href="v.url" :key="i">{{ v.name }}</a>
						</p>
					</div>
				</div>
				<div class="erweima">
					<img :src="url + sysInfo.accountQrCode" alt="" />
					<div style="color: #99a3ad;font-size: 12px;text-align: center;padding:4px 0 0 0">微信公众号</div>
				</div>
			</div>
			<div class="footer_spt">
				<span class="copyright">©蜀ICP备10001234号-1 陕西陕煤检测科技有限公司版权所有</span>
				<span>技术支持：成都青软青之软件有限公司</span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			url: window.SITE_CONFIG.baseUrl + '/checkmall-file/api/file/preview/',
			sysInfo: {},
		}
	},
	created() {
		this.getSys()
	},
	methods: {
		getSys() {
			this.$http.get(this.$api.systemApi.getSys).then(({ data }) => {
				this.sysInfo = data.data
			})
		},
		joinFavorite() {
			var url = window.location
			var title = document.title
			var ua = navigator.userAgent.toLowerCase()
			if (ua.indexOf('360se') > -1) {
				alert('由于360浏览器功能限制，请按 Ctrl+D 手动收藏！')
			} else if (ua.indexOf('msie 8') > -1) {
				window.external.AddToFavoritesBar(url, title) //IE8
			} else if (document.all) {
				try {
					window.external.addFavorite(url, title)
				} catch (e) {
					alert('您的浏览器不支持,请按 Ctrl+D 手动收藏!')
				}
			} else if (window.sidebar) {
				window.sidebar.addPanel(title, url, '')
			} else {
				alert('您的浏览器不支持,请按 Ctrl+D 手动收藏!')
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.page_footer {
	height: 138px;
	background: #001933;
	overflow: hidden;
	.footer_wrapper {
		width: 1200px;
		margin: 0 auto;
	}
	.footer_info {
		display: flex;
		align-items: flex-end;
		justify-content: space-between;
		padding-top: 10px;
		padding-bottom: 7px;
		border-bottom: 1px solid rgba(255, 255, 255, 0.1);
		.f_menu {
			display: flex;
			flex: 1;
			justify-content: space-between;
			color: #fff;
			.mitem {
				h3 {
					font-size: 14px;
				}
				p {
					span,
					a {
						margin-right: 36px;
						color: #99a3ad;
						cursor: pointer;
					}
				}
			}
		}
		.erweima {
			margin-left: 100px;
			img {
				height: 72px;
				width: 72px;
			}
		}
	}
	.footer_spt {
		text-align: center;
		margin-top: 14px;
		font-size: 12px;
		color: #99a3ad;
		.copyright {
			margin-right: 100px;
		}
	}
}
</style>
